import { useMemo } from "react";
import { AnalyticsDashboard } from "@/features/analytics/AnalyticsDashboard";
import { AnalyticsFiltersProvider } from "@/features/analytics/filters-context";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import { Skeleton } from "@/components/ui/Skeleton";

export default function VistaGeneral() {
  const { usuarioInfo, loadingUsuarioInfo } = useCurrentUser();

  const clienteIntermedioId = usuarioInfo?.clientesIntermedios?.[0]?.id ?? null;

  const lockedFilters = useMemo(
    () => (clienteIntermedioId ? { clienteIntermedioId } : null),
    [clienteIntermedioId],
  );

  if (loadingUsuarioInfo) {
    return (
      <div className="space-y-3">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-96 w-full" />
      </div>
    );
  }

  if (!clienteIntermedioId) {
    return (
      <div className="text-sm text-muted-foreground">
        No encontramos información del cliente intermedio asociado a tu cuenta.
      </div>
    );
  }

  return (
    <AnalyticsFiltersProvider
      initialState={lockedFilters ?? undefined}
      lockedFilters={lockedFilters ?? undefined}
    >
      <AnalyticsDashboard />
    </AnalyticsFiltersProvider>
  );
}
